import { authorisedContact } from "../../config/contact";
import React from "react";
import {
  FaWhatsapp,
  FaPhoneAlt,
  FaArrowUp,
} from "react-icons/fa";

const FloatingContactButtons = () => {

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div style={styles.container}>

      {/* WhatsApp */}

      <a
        href={authorisedContact.whatsapp}
        target="_blank"
        rel="noreferrer"
        style={{
          ...styles.button,
          background: "#25D366",
        }}
        title="Chat on WhatsApp"
        aria-label="Chat with EMEI on WhatsApp"
      >
        <FaWhatsapp size={28} />
      </a>

      {/* Call */}

      <a
        href={authorisedContact.telephone}
        style={{
          ...styles.button,
          background: "#0EA5E9",
        }}
        title="Call EMEI"
        aria-label="Call EMEI at +91 94339 30490"
      >
        <FaPhoneAlt size={22} />
      </a>

      {/* Back To Top */}

      <button
        onClick={scrollTop}
        style={{
          ...styles.button,
          background: "#0F766E",
          border: "none",
          cursor: "pointer",
        }}
        title="Back To Top"
      >
        <FaArrowUp size={20} />
      </button>

    </div>
  );
};

const styles = {

  container: {
    position: "fixed",
    right: "22px",
    bottom: "22px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    zIndex: 9999,
  },

  button: {
    width: "58px",
    height: "58px",
    borderRadius: "50%",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    boxShadow: "0 10px 25px rgba(0,0,0,.18)",
    transition: "all .3s ease",
  },

};

export default FloatingContactButtons;